/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
import React, { useEffect, useMemo, useState } from 'react';
import { DatePicker } from 'pg-ui-library';
import styled from 'styled-components';

const commonFieldStyle = {
  width: '100%',
  height: '35px',
  borderRadius: '7px',
  border: '1px solid #ccc',
  paddingTop: '2px',
  paddingBottom: '2px',
  boxSizing: 'border-box',
  fontSize: '1.5rem',
} as const;

const PickerWrapper = styled.div`
  width: 100%;

  .common-date-input {
    ${commonFieldStyle}
  }
`;

const FieldWrapper = styled.div`
  width: 100%;
`;

const Label = styled.span`
  display: block;
  margin-bottom: 5px;
  font-size: 1.6rem;
  color: #1a1a32;
`;

const RangeText = styled.div`
  font-size: 1.6rem;
  color: #666;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

interface Props {
  onDateChange?: (date: Date | null) => void;
  initialDate?: Date | null;
  minDate?: Date | null;
  maxDate?: Date | null;
  isEdit?: boolean;
}

const formatDate = (date: Date) => {
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

const getMondayToSunday = (date: Date) => {
  const selected = new Date(date);
  const day = selected.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;

  const monday = new Date(selected);
  monday.setHours(0, 0, 0, 0);
  monday.setDate(selected.getDate() + diffToMonday);

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  return { monday, sunday };
};

const WorkWeekDatepicker: React.FC<Props> = ({
  onDateChange,
  initialDate = null,
  minDate = null,
  maxDate = null,
  isEdit = false,
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(initialDate);
  const [showPicker, setShowPicker] = useState(!initialDate);

  useEffect(() => {
    setSelectedDate(initialDate);
    setShowPicker(!initialDate);
  }, [initialDate]);

  const weekRangeText = useMemo(() => {
    if (!selectedDate) return '';

    const { monday, sunday } = getMondayToSunday(selectedDate);
    return `${formatDate(monday)} - ${formatDate(sunday)}`;
  }, [selectedDate]);

  const handleChange = (value: any) => {
    let date: Date | null = null;

    if (value instanceof Date) {
      date = value;
    } else if (value?.target?.value) {
      date = new Date(value.target.value);
    } else if (value) {
      date = new Date(value);
    }

    if (date && !Number.isNaN(date.getTime())) {
      setSelectedDate(date);
      setShowPicker(false);
      onDateChange?.(date);
    }
  };

  return (
    <FieldWrapper>
      <Label>Work Week *</Label>

      {showPicker ? (
        <PickerWrapper>
          <DatePicker
            id="workWeek"
            name="workWeek"
            label=""
            selected={selectedDate}
            onChange={handleChange}
            placeholderText="Enter date"
            minDate={minDate}
            maxDate={maxDate}
            className="common-date-input"
            autoComplete="off"
          />
        </PickerWrapper>
      ) : (
        <RangeText onClick={() => setShowPicker(isEdit ? false : true)}>{weekRangeText}</RangeText>
      )}
    </FieldWrapper>
  );
};

export default WorkWeekDatepicker;
